import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent } from './copy-all-outlined.svg';


export const CopyAllOutlined: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <ReactComponent />
  </SvgIcon>
);
